"use strict";
/**
 * Runtime Plugin Base Class & Interface for man-core.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MANPlugin = void 0;
class MANPlugin {
    name;
    constructor(name) {
        this.name = name;
    }
}
exports.MANPlugin = MANPlugin;
